import { render, staticRenderFns } from "./PendingPlans.vue?vue&type=template&id=03001d48&"
import script from "./PendingPlans.vue?vue&type=script&lang=js&"
export * from "./PendingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports